module.exports = __webpack_public_path__ + "static/media/re.9c9d700b.svg";